import { ref, onMounted, onUnmounted, Ref, nextTick } from "vue";
import { useMainStore } from "@/mainStore";

// export const focusTrapProps = ["focusTrapContainer"];
// export const focusTrapPropsObject = { focusTrapContainer: [HTMLElement, String] };
// export type FocusTrapProps = {
//     focusTrapContainer: HTMLElement | string;
// };

const focusQuery = ["input", "select", "textarea", "button", "object", "a[href]", "area[href]", "[tabindex]"].map(i => i + ':not([disabled]):not([tabindex="-1"])').join(", ");
export function focusTrapSetup(focusTrapContainer: Ref<HTMLElement>) {
    const mainStore = useMainStore();
    const focusTrapEnabled = ref(true);

    const focusTrapSetEnabled = (input: boolean) => {
        focusTrapEnabled.value = input;
    };
    const handleTabKey = (event: KeyboardEvent) => {
        if (event.key !== "Tab" || !focusTrapEnabled.value) return;

        const focusableElements = Array.from(focusTrapContainer.value.querySelectorAll(focusQuery)).filter(isElementVisible) as HTMLElement[];
        if (focusableElements.length === 0) {
            event.preventDefault();
            return;
        }

        const firstFocusableEl = focusableElements[0];
        const lastFocusableEl = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) {
            // Shift + Tab
            if (document.activeElement === firstFocusableEl || !focusTrapContainer.value.contains(document.activeElement)) {
                event.preventDefault();
                lastFocusableEl.focus();
            }
        } else {
            // Tab
            if (document.activeElement === lastFocusableEl || !focusTrapContainer.value.contains(document.activeElement)) {
                event.preventDefault();
                firstFocusableEl.focus();
            }
        }
    };
    // Filter focusable visible elements since non-visible elements are not focusable.
    const isElementVisible = (element: HTMLElement | Element) => {
        if (typeof element.checkVisibility == "function") {
            return element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
        } else {
            while (element != null) {
                const style = window.getComputedStyle(element);
                if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") {
                    return false;
                }
                element = element.parentElement!;
            }
            return true;
        }
    };

    onMounted(async () => {
        document.addEventListener("keydown", handleTabKey);
        const focusableElements = Array.from(focusTrapContainer.value.querySelectorAll(focusQuery)) as HTMLElement[];
        if (focusableElements.length > 0) {
            await nextTick();
            const autofocusedElement = document.querySelector("[autofocus]") as HTMLElement | null;
            const targetElementToFocus = autofocusedElement != null && focusableElements.includes(autofocusedElement) ? autofocusedElement : focusableElements[0];
            targetElementToFocus.focus();
        }
    });
    onUnmounted(() => {
        document.removeEventListener("keydown", handleTabKey);
        mainStore.removeLastActiveModal();
        mainStore.toggleFocusTrapActiveModals(true);
    });

    mainStore.toggleFocusTrapActiveModals(false);
    mainStore.addActiveModal(focusTrapEnabled);

    return {
        focusTrapSetEnabled,
    };
}
